import statistic from '../../api/statistic'
import application from '../../api/application'
import dashboard from '../../api/dashboard'
import lodash from 'lodash';

const state = {
  appList: [], // 应用下拉选项
  appTotalPage: null, // 应用下拉选项总页数
  pageTotal: 0,
  loading: true,
  statisticList: [],
  detailList: [],
  chartDate: [],
  reqCount: [],
  loginCount: [],
  allRemain: null,
  monthCount: null,
  statisticLoading: true,
  detailLoading: true

};

const actions = {
  // 获取剩余量/月耗
  async getOverview ({ commit }, payload) {
    const response = await dashboard.getOverview(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_VIEWLIST', {
        allRemain: data.data.allRemain,
        overView: data.data.overView
      });
    }
  },
  // 获取应用
  async getAppList ({ commit }, payload) {
    const params = lodash.cloneDeep(payload);
    delete params.init;
    const response = await application.getAppList(params);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_APP', {
        appList: data.data,
        size: data.size,
        total: data.total
      });
    }
  },
  // 统计
  async getStatistics ({ commit }, payload) {
    const response = await statistic.getStatistics(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_STATISTIC', {
        statisticList: data.data
      });
      commit('UPDATE_STATISTIC_LOADING', {
        statisticLoading: false
      });
    }
  },
  // 统计明细
  async getDetails ({ commit }, payload) {
    const response = await statistic.getDetails(payload);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_DETAIL', {
        detailList: data.data,
        pageTotal: data.total
      });
      commit('UPDATE_DETAIL_LOADING', {
        detailLoading: false
      });
    }
  }
};

const mutations = {
  'UPDATE_VIEWLIST': (state, payload) => {
    state.allRemain = payload.allRemain;
    state.monthCount = 0;
    payload.overView.forEach(ele => {
      state.monthCount += ele.count
    });
  },
  'UPDATE_APP': (state, payload) => {
    state.appList = []
    payload.appList.forEach(ele => {
      state.appList.push(ele.appName)
    })
    state.appList.unshift('全部应用')
    state.appList = Array.from(new Set(state.appList))
    state.appTotalPage = Math.ceil(payload.total / 20)
  },
  'UPDATE_STATISTIC': (state, payload) => {
    state.chartDate = []
    state.reqCount = []
    state.loginCount = []
    state.statisticList = payload.statisticList;
    payload.statisticList && payload.statisticList.forEach(ele => {
      state.chartDate.push(ele.time)
      state.reqCount.push(ele.allReqCount)
      state.loginCount.push(ele.sucReqCount)
    });
    state.pageTotal = payload.pageTotal;
  },
  'UPDATE_DETAIL': (state, payload) => {
    state.detailList = payload.detailList;
    state.pageTotal = payload.pageTotal;
  },
  'UPDATE_STATISTIC_LOADING': (state, payload) => {
    state.statisticLoading = payload.statisticLoading;
  },
  'UPDATE_DETAIL_LOADING': (state, payload) => {
    state.detailLoading = payload.detailLoading;
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/statistic.js